"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumCustomerIdentity = void 0;
var TealiumCustomerIdentity;
(function (TealiumCustomerIdentity) {
    TealiumCustomerIdentity["IDENTIFIED"] = "identified";
    TealiumCustomerIdentity["ANONYMOUS"] = "anonymous";
})(TealiumCustomerIdentity || (exports.TealiumCustomerIdentity = TealiumCustomerIdentity = {}));
//# sourceMappingURL=CustomerTypes.js.map